import { apiFetch } from "@/client/lib/api";

/** Staff-only client for managing the tenant<->Outline documentation mapping. */

export interface TenantSummary {
  id: string;
  name: string;
  slug: string;
  status: string;
}

export interface OutlineCollectionSummary {
  id: string;
  name: string;
}

export interface DocSourceSummary {
  id: string;
  tenantId: string;
  type: "collection" | "document";
  outlineId: string;
  title: string;
  enabled: boolean;
  lastSyncedAt: string | null;
  lastSyncError: string | null;
  createdAt: string;
}

export interface CreateSourceInput {
  tenantId: string;
  type: "collection" | "document";
  outlineId: string;
  title: string;
}

export interface SyncResult extends DocSourceSummary {
  pages: number;
  assets: number;
}

export const docsAdminApi = {
  listTenants: () => apiFetch<{ tenants: TenantSummary[] }>("/tenants"),
  listCollections: () =>
    apiFetch<{ collections: OutlineCollectionSummary[] }>("/staff/docs/outline/collections"),
  listSources: (tenantId: string) =>
    apiFetch<{ sources: DocSourceSummary[]; slackConfigured: boolean }>(
      `/staff/docs/sources?tenantId=${encodeURIComponent(tenantId)}`,
    ),
  createSource: (input: CreateSourceInput) =>
    apiFetch<DocSourceSummary>("/staff/docs/sources", { method: "POST", json: input }),
  syncSource: (id: string) =>
    apiFetch<SyncResult>(`/staff/docs/sources/${encodeURIComponent(id)}/sync`, { method: "POST" }),
  notifySource: (id: string) =>
    apiFetch<{ status: "sent" | "skipped" | "failed" }>(
      `/staff/docs/sources/${encodeURIComponent(id)}/notify`,
      { method: "POST" },
    ),
  deleteSource: (id: string) =>
    apiFetch<void>(`/staff/docs/sources/${encodeURIComponent(id)}`, { method: "DELETE" }),
};
